module.exports = __webpack_public_path__ + "static/026_001-ba9d679e26f920b659411a2e58b7b383.jpg";